import request from '@/utils/request'


// 查询任务列表
export function listTask(query) {
  return request({
    url: '/task/task/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询任务分页
export function pageTask(query) {
  return request({
    url: '/task/task/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询任务详细
export function getTask(data) {
  return request({
    url: '/task/task/detail',
    method: 'get',
    params: data
  })
}

// 新增任务
export function addTask(data) {
  return request({
    url: '/task/task/add',
    method: 'post',
    data: data
  })
}

// 修改任务
export function updateTask(data) {
  return request({
    url: '/task/task/edit',
    method: 'post',
    data: data
  })
}

// 删除任务
export function delTask(data) {
  return request({
    url: '/task/task/delete',
    method: 'post',
    data: data
  })
}
